module.exports = __webpack_public_path__ + "1c824216f354218b04b25a57e0f7ab1f.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/blue.png
// module id = 2151
// module chunks = 0